import { useNavigate } from "react-router-dom";
import React from "react";
import { Helmet } from "react-helmet";
import HeroSection from "./HeroSection";
import Navbar from "../../components/Navbar";
import { Search } from "lucide-react";
import SearchFilter from "./SearchFilter";
import TopHotelsAndRestaurants from "./TopHotelsAndRestaurants";
import Testimoinals from "./Testimonials";
import DownloadApp from "./DownloadApp";
import SubscribeNewsletter from "./SubscribeNewsletter";
import Footer from "../../components/Footer";
import HotelBooking from "./HotelBooking";
import AdsSection from './AdsSection';
import { useSettings } from "../../context/SettingsContext";

function Home() {
  const { settings } = useSettings();
  const showHotels = settings?.showHotels;

  return (
    <>
      {/* <Navbar /> */}
      <Helmet>
        <title>Dine Easy - Home</title>
      </Helmet>
      <HeroSection />
      {showHotels === true && <HotelBooking />}
      <SearchFilter />
      {/* <TopHotelsAndRestaurants show={true} prefer="restaurants" /> */}
      <AdsSection show={true} prefer="restaurants" />
      <Testimoinals />
      <DownloadApp />
      <SubscribeNewsletter />
      {/* <Footer /> */}
    </>
  );
}

export default Home;
